import { useState, useEffect } from "react";
import { ReactComponent as ArrowIcon } from "../../../images/arrow-small-left.svg";
import { ReactComponent as DownloadIcon } from "../../../images/download.svg";
import Table from "components/elements/Table";
import Select from "components/elements/Select";
import IconInput from "components/elements/IconInput";
import DateInput from "components/elements/DateInput";
import { useOutletContext } from "react-router-dom";
import dataProvider from "core/DataProvider";
import { toast } from "react-hot-toast";
import Exporter from "components/elements/Exporter";
import utility from "core/Utils";

const headerMap = {
  channel: "Channel Name",
  date: "Date",
  description: "Description",
  start_time: "Start Time",
  end_time: "End Time",
  length: "Length",
};

const exportHeaders = [
  { label: "ChannelName", key: "channel" },
  { label: "Date", key: "date" },
  { label: "Description", key: "description" },
  { label: "StartTime", key: "start_time" },
  { label: "EndTime", key: "end_time" },
  { label: "Length", key: "length" },
];

const FeedMissing = () => {
  const [data, setData] = useState([]);
  const [periodFrom, setPeriodFrom] = useState("");
  const [periodTo, setPeriodTo] = useState("");
  const [channel, setChannel] = useState(null);
  const [channels, setChannels] = useState([]);
  const [exportFormat, setExportFormat] = useState({
    value: "csv",
    label: "CSV",
  });

  const [formCollapsed, setFormCollapsed] = useState(false);
  const [commonSegmentCollapsed, setCommonSegmentCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);

  const token = useOutletContext();

  const getChannels = async () => {
    try {
      let channels = await dataProvider.network.get(`min-master/channels`);
      channels = channels.map(x => ({ value: x.id, label: x.name }));

      setChannels([{ value: 0, label: "All" }, ...channels]);
      setChannel({ value: 0, label: "All" });
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch channels");
    }
  };

  const submit = async e => {
    e.preventDefault();

    if (!periodFrom || !periodTo) {
      toast.error("Please select the mandatory fields");
      return;
    }

    setLoading(true);

    let data = {
      period_from: periodFrom,
      period_to: periodTo,
      channels: channel && channel.length ? channel.map(x => x.value) : [],
    };

    try {
      let records = await dataProvider.network.post("feedmissing-report", data);

      setData(records);
      setFormCollapsed(true);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load feedmissing report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getChannels();
  }, []);

  return (
    <section id="feedmissing-report">
      <div className="grey-box">
        <div className="left">
          <h3>FeedMissing Report</h3>
          <h4>Reports &gt; FeedMissing Report</h4>
        </div>
        <div className="right">
          {loading && (
            <div className="loader">
              <div className="lds-hourglass"></div>
            </div>
          )}
        </div>
      </div>
      <div className="flex mtop">
        <div
          className={formCollapsed ? "form-wrapper collapsed" : "form-wrapper"}
        >
          <div
            className={
              commonSegmentCollapsed ? "form-segment collapsed" : "form-segment"
            }
          >
            <div className="segment-head">
              <h6>Common</h6>
            </div>
            <div className="form-segment">
              <div className="segment-body">
                <DateInput
                  value={periodFrom}
                  onChange={val => setPeriodFrom(val)}
                  placeholder="Period from"
                />
                <DateInput
                  value={periodTo}
                  onChange={val => setPeriodTo(val)}
                  placeholder="Period to"
                />
                <Select
                  options={channels}
                  value={channel}
                  onChange={val => setChannel(val)}
                  placeholder="Channel"
                />
              </div>
            </div>
          </div>
          <button onClick={submit}>Submit</button>
          <div
            className="collapser"
            onClick={e => setFormCollapsed(!formCollapsed)}
          >
            <ArrowIcon />
          </div>
        </div>
        <div className="results-wrapper flex-full">
          <div className="head flex flex-v-center">
            <h3>Results</h3>
            <div className="right">
              <div className="flex flex-v-center">
                <div className="el">
                  <IconInput placeholder="Search" icon="search" />
                </div>
                <div className="el">
                  <Select
                    value={exportFormat}
                    onChange={val => {
                      setExportFormat(val);
                    }}
                    options={[
                      { value: "csv", label: "CSV" },
                      { value: "xlsx", label: "XLSX" },
                    ]}
                    placeholder="Format"
                  />
                </div>
                <Exporter
                  format={exportFormat.value}
                  data={data}
                  headers={exportHeaders}
                  filename={`FeedMiss_${periodFrom}_${periodTo}.${exportFormat.value}`}
                />
              </div>
            </div>
          </div>
          <div className="results">
            <Table headers={headerMap} data={data} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeedMissing;
